var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-top":"60px"}},[_c('h2',[_vm._v(" 押金："+_vm._s(_vm.user.plan.deposit)+"元 ")]),_c('mt-button',{staticClass:"user-btn",attrs:{"type":"primary"},on:{"click":_vm.submit}},[_vm._v("支付押金")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }